import { DetailField } from '@/components/ui/details-panel';
import { EntityLink } from '@/components/ui/entity-link';
import { useEntityModalContext } from '@/contexts/EntityModalContext';

interface EntityDetailFieldProps {
	label: string;
	value?: string | null;
	entityId?: string | null;
	entityType?: string;
	className?: string;
}

export function EntityDetailField({
	label,
	value,
	entityId,
	entityType,
	className
}: EntityDetailFieldProps) {
	const { openEntityModal } = useEntityModalContext();

	// If we have entityId and entityType, render as a clickable link
	if (entityId && entityType && value) {
		return (
			<DetailField
				label={label}
				className={className}
				value={
					<EntityLink
						entityId={entityId}
						entityType={entityType}
						displayText={value}
						onEntityClick={openEntityModal}
					/>
				}
			/>
		);
	}

	// Otherwise, render as a regular DetailField
	return (
		<DetailField
			label={label}
			value={value ?? 'Not set'}
			className={className}
		/>
	);
}
